import script from "./caasPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./caasPlans.vue?vue&type=script&setup=true&lang=js"

import "./caasPlans.vue?vue&type=style&index=0&id=ce9a3d64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce9a3d64"]])

export default __exports__